<template>
  <a-layout class="layout-3">
    <Header :flag="flag & 4" />
    <a-layout>
      <Sidebar :flag="flag & 129" />
      <a-layout>
        <!-- nav:2 + header:4 -->
        <Nav :flag="flag & 6" />
        <Content />
      </a-layout>
    </a-layout>
  </a-layout>
</template>
<script lang="ts">
import { Content, Header, Nav, Sidebar } from "@/components/Layouts";
import { Component, Vue, Watch } from "vue-property-decorator";
@Component({
  name: "Layout3",
  components: {
    Header,
    Content,
    Sidebar,
    Nav,
  },
})
export default class extends Vue {
  flag = 127;

  created() {
    this.onNavBarShow(this.$store.state.Menu.menuShowFlg);
  }

  @Watch("$store.state.Menu.menuShowFlg")
  onNavBarShow(value: number) {
    this.flag = value;
  }
}
</script>
<style lang="less">
.layout-3,
.ant-layout {
  height: 100%;
  width: 100%;
}
</style>
